class TowerPreview {
    static Refresh = 'refresh';
    static Property = 'property';
    static Tower = 'tower';
    static Room = 'room';
    static Contact = 'contact';
    static Document = 'document';
}
export default TowerPreview;